/**
 * Static copy for the RateQuote lead partner — replace with API/CMS later.
 */

/** Exact value sent as `leadPartnerName` to Zoho for this partner. */
export const RATE_QUOTE_ZOHO_LEAD_PARTNER_NAME = 'Rate Quote';

export const RATE_QUOTE_LOGO_URL =
  'https://oneill-static-assets.s3.us-east-1.amazonaws.com/rate-quote-logo.svg';

/**
 * Exact `question` strings sent to Zoho — keep in sync with form labels.
 */
export const rateQuoteApplyQuestions = {
  agencyName: 'Agency Name',
  primaryContactName: 'Primary Contact Name',
  email: 'Email',
  phone: 'Phone Number',
  activeAgentsCount: 'How many active agents do you currently have?',
  writingAcaBusiness: 'Are you currently writing ACA business?',
  inboundCallsAvailable:
    'Do you have agents available to consistently take inbound calls?',
  transfersPerDay:
    'How many inbound call transfers per day could your team handle?',
  startTimeline: 'How quickly could you get started if approved?',
  notesOptional: 'Anything else we should know? (optional)'
};

export const rateQuoteApplyTransfersOptions = [
  { value: '<25', label: '<25' },
  { value: '25-75', label: '25-75' },
  { value: '76+', label: '76+' }
];

export const rateQuoteApplyStartOptions = [
  { value: 'Immediately', label: 'Immediately' },
  { value: 'Within 2 weeks', label: 'Within 2 weeks' },
  { value: '30+ days', label: '30+ days' }
];

export const leadPartnersHero = {
  pageTitle: 'Our Exclusive Lead Partners',
  instruction: 'Please click on a partner below to view more information.'
};

export const partners = {
  rateQuote: {
    id: 'rateQuote',
    label: 'RateQuote',
    zohoLeadPartnerName: RATE_QUOTE_ZOHO_LEAD_PARTNER_NAME,
    tagline:
      'Discounted inbound ACA leads through live call transfers — driven by real-time paid search intent.'
  },
  other: {
    id: 'other',
    label: 'Other',
    comingSoon: 'Coming Soon'
  }
};

export const rateQuoteDetail = {
  aboutHeading: 'About this partnership',
  paragraphs: [
    "We've partnered with RateQuote to give O'Neill agencies access to discounted inbound ACA leads through live call transfers generated from paid search. These are some of the best-performing lead sources in the under-65 individual health market, driven by real-time consumer search intent.",
    'These are high-intent consumers actively searching for coverage and connected in real time. Leads are compliant, transparent in origin, and supported by an ongoing feedback loop to help improve performance over time.'
  ],
  fitHeading: 'This is a good fit for agents who:',
  fitBullets: [
    'Are actively writing ACA business',
    'Have agents available to consistently take inbound calls',
    'Can handle consistent call volume throughout the day',
    'Are looking to scale in a more structured way'
  ],
  applyCard: {
    title: 'Ready to Apply?',
    description:
      "Fill out a quick application and our team will review your agency's fit within 2–3 business days.",
    buttonLabel: 'Apply Now',
    disclaimer:
      "Participation may be limited based on carrier availability and agency eligibility. O'Neill Marketing reserves the right to evaluate applicants."
  },
  modal: {
    title: 'Apply Now',
    subtitle: 'Complete the form below — our team will be in touch shortly.',
    submitLabel: 'Submit Application'
  }
};
